import { useNavigate } from "react-router-dom";
import { edit } from "../../asset";
import SubHeadings from "../../components/SubHeadings";
import { Info } from "./StaffOverview";
import { Staff } from "../../types/staff";
import { useEffect, useState } from "react";
import payrollManagement from "../../api/payrollManagementApis";
import { SalaryStructureResponse } from "../../types/payrollType";

interface Props {
  data: Staff;
  salary: SalaryStructureResponse;
}

export default function BankAndStatutoryDetails({ data, salary }: Props) {
  const navigate = useNavigate();
  const [employeePF, setEmployeePF] = useState(false);
  const [proffTax, setProffTax] = useState(false);

  const handleUpdateClick = () => {
    navigate(`/staff/staff-profile/${data.staffId}`, {
      state: { showReminder: true, scrollTo: "financial" },
    });
  };

  const handleStatutoryEdit = () => {
    const staffId = data.staffId;
    const storageKey = `payroll-progress-${staffId}`;

    sessionStorage.setItem(
      storageKey,
      JSON.stringify({
        step: 2,
        completed: false,
      }),
    );

    navigate(`/payroll-management/add-payroll/${staffId}?step=2`);
  };

  useEffect(() => {
    if (!salary) return;

    setEmployeePF(!!salary.employeePfEnabled);
    setProffTax(!!salary.professionalTaxEnabled);
  }, [salary]);

  return (
    <div className="grid gap-2 w-full">
      <div className="bg-white py-[18px] px-[22px] rounded-lg flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <SubHeadings
            text="Bank Details"
            textColor="text-neutral-400"
            bgColor="bg-neutral-400"
          />
          <button
            onClick={handleUpdateClick}
            className="bg-warning-50 py-1 px-2 flex gap-2 items-center"
          >
            <img src={edit} alt="" />
            <span className=" text-warning-700 text-xs font-medium">Edit</span>
          </button>
        </div>
        <div className="grid gap-[10px]">
          <Info
            label="A/c Holder’s Name"
            value={data?.accountHolderName || "---"}
          />
          <Info label="A/c Number" value={data?.aadhaarNumber || "---"} />
          <Info label="IFSC Code" value={data?.ifscCode || "---"} />
          <Info label="Bank Name" value={data?.bankName || "---"} />
          <Info label="Branch Name" value={data?.branchName || "---"} />
        </div>
      </div>
      <div className="bg-white py-[18px] px-[22px] rounded-lg flex flex-col gap-4">
        <div className="flex justify-between items-center">
          <SubHeadings
            text="Statutory Components"
            textColor="text-neutral-400"
            bgColor="bg-neutral-400"
          />
          <button
            onClick={handleStatutoryEdit}
            className="bg-warning-50 cursor-pointer py-1 px-2 flex gap-2 items-center"
          >
            <img src={edit} alt="" />
            <span className="text-warning-700 text-xs font-medium">Edit</span>
          </button>
        </div>
        <div className="grid gap-[10px]">
          <label className="flex items-center gap-2 text-sm text-neutral-500">
            <input
              type="checkbox"
              checked={proffTax}
              disabled
              className="w-[13px] h-[13px] cursor-pointer"
            />
            Professional Tax
          </label>
          <label className="flex items-center gap-2 text-sm text-neutral-500">
            <input
              type="checkbox"
              checked={employeePF}
              disabled
              className="w-[13px] h-[13px] cursor-pointer"
            />
            Employee PF
          </label>
        </div>
      </div>
    </div>
  );
}
